export enum EvaluationsOnLoadOfForm {
	No = 0,
	Yes = 1
}